import {
  CardView,
  Collection,
  SkeletonCollection,
  IllustratedMessage,
  Heading,
} from "@react-spectrum/s2";
import { useNavigate } from "react-router";

import { useExpressTemplates } from "@app/hooks/expressTemplates.js";

import { TemplateCard } from "./TemplateCard.js";

import EmptyIcon from "@react-spectrum/s2/illustrations/gradient/generic1/FolderOpen";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const TemplateList = () => {
  const navigate = useNavigate();

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
  } = useExpressTemplates();

  const templates = data?.pages?.flatMap((page) => page.documents) || [];
  const loadingState = isError
    ? "error"
    : isLoading
      ? "loading"
      : isFetchingNextPage
        ? "loadingMore"
        : "idle";

  const renderEmptyState = () => (
    <IllustratedMessage size="M" styles={style({ marginY: 64 })}>
      <EmptyIcon />
      <Heading>No templates found</Heading>
    </IllustratedMessage>
  );

  return (
    <CardView
      loadingState={loadingState}
      onLoadMore={fetchNextPage}
      isLoadingMore={isFetchingNextPage}
      hasMore={hasNextPage}
      selectionMode="single"
      selectionStyle="highlight"
      onSelectionChange={(selectedKeys) => navigate([...selectedKeys][0])}
      renderEmptyState={renderEmptyState}
      aria-label="Template List"
    >
      <Collection items={templates}>
        {(item) => <TemplateCard template={item} />}
      </Collection>
      {isFetching && (
        <SkeletonCollection>
          {() => (
            <TemplateCard
              template={{
                id: "skeleton",
                name: "Loading...",
                thumbnailUrl: "",
              }}
            />
          )}
        </SkeletonCollection>
      )}
    </CardView>
  );
};

TemplateList.propTypes = {};
